module.exports = __webpack_public_path__ + "img/BonofStrength.4ff05d26.png";